import {Button} from 'primereact/button';
import {Card} from 'primereact/card';
import {Divider} from 'primereact/divider';
import {Image} from 'primereact/image';
import {FC, memo, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {Product} from '../data/categories';
import {useAppSelector, useTranslation} from '../hooks';
import {languageState} from '../redux/slices/app';

interface ProductGridProps {
  products: Product[];
}

const ProductGrid: FC<ProductGridProps> = ({products}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const selectedLanguage = useAppSelector(languageState);

  const onClick = useCallback(
    (url: string) => navigate('/' + selectedLanguage + t(url)),
    [navigate, t, selectedLanguage],
  );

  return (
    <div className="grid grid-cols-3 gap-4 p-4 sm:justify-content-center md:justify-content-start ">
      {products
        .filter((p) => p.active === true)
        .map((product) => (
          <Card
            key={product.key}
            className="shadow-md cursor-pointer flex flex-col items-center justify-center text-center">
            <picture className="w-full h-full">
              <source srcSet={product.avifImage} type="image/avif" />
              <source srcSet={product.webpImage} type="image/webp" />
              <Image
                src={product.imageUrl}
                alt={t(product.title)}
                width="250"
                height="200"
                imageStyle={{objectFit: 'cover'}}
                preview
              />
            </picture>
            <Divider />

            <Button
              className="text-center font-semibold mt-5"
              label={t(product.title)}
              aria-label={t(product.title)}
              severity="contrast"
              onClick={() => onClick(product.url)}
            />
          </Card>
        ))}
    </div>
  );
};

export default memo(ProductGrid);
